/**
 * @param {string|string[]} icon - Icon name(s); array limited to first 2
 * @returns {string[]} Array of require() paths to SVG assets
 */
export const getIcon = (icon) => {
    let src = [];

    if (icon) {
        if (typeof icon === "string") {
            src.push(require(`../assets/icons/${icon}.svg`));
        } else {
            icon.forEach((item, i) => {
                if (i < 2) {
                    src.push(require(`../assets/icons/${item}.svg`));
                }
            });
        }
    }

    return src;
};

/**
 * @param {string} name - Icon module name under assets/icons/raw
 * @returns {JSX.Element}
 */
export const getRawIcon = (name) => {
    const { Icon } = require(`../assets/icons/raw/${name}.js`);
    return <Icon />;
};
